import React from 'react';
import './DashboardHome.css';
import { useTranslation } from 'react-i18next';
import TextWithHTML from '../../../TextWithHTML/TextWIthHTML';

const DashboardHome = () => {
    const { t } = useTranslation('common');
    return (
        <>
            <div className="dashboard-home">
                <div className='row justify-content-center'>
                    <div className='col-md-10'>
                        <h6 className="home-content-one"><TextWithHTML content={t('home-content-one')} /></h6>
                        <h4 className="home-content-two"><TextWithHTML content={t('home-content-two')} /></h4>
                        <p className="home-content-three"><TextWithHTML content={t('home-content-three')} /></p>
                    </div>
                </div>
            </div>
        </>
    );
};

export default DashboardHome;